import React, { useState } from "react";
import { Button, Form, message } from "antd";
import ActionsModal from "../../common/components/ActionsModal";
import AreaAddForm from "./AreaAddForm";
import { useMutation } from "react-query";
import { AxiosAreasAPI } from "../Api";
import moment from "moment";
import { onSuccess } from "../../common/components/AreasPositions/RequestSolvers";

const AreaAddModal = ({ reload }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const { mutate } = useMutation(["createArea"], AxiosAreasAPI.createArea, {
    onError: (error) => {
      error.response.status === 409
        ? message.error("Já existe uma área com este código!")
        : message.error(
            "Não foi possível realizar a solicitação de criação para a nova área!",
          );
    },
    onSuccess: () =>
      onSuccess(
        reload,
        form,
        () => setIsModalOpen(false),
        "Área criada com sucesso!",
      ),
  });

  const createArea = (values) => {
    mutate({
      ...values,
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
    });
  };

  return (
    <>
      <ActionsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        onSubmit={createArea}
        form={form}
        button={
          <Button
            type={"primary"}
            onClick={() => setIsModalOpen(true)}
            style={{ marginRight: 20 }}
          >
            + Adicionar área
          </Button>
        }
        context={"Adicionar área"}
      >
        <AreaAddForm form={form} />
      </ActionsModal>
    </>
  );
};

export default AreaAddModal;
